import axios from "../utils/axios";

export const getMailGroups = () => {
    return axios.get(`/MailGroup/GetDetailList`);
};

export const addMailGroup = (payload) => {
    return axios.post(`/MailGroup/Add`, payload);
};

export const updateMailGroup = (payload) => {
    return axios.post(`/MailGroup/Update`, payload);
};

export const deleteMailGroup = (payload) => {
    return axios.delete(`/MailGroup/Delete?id=${payload}`);
};

export const addMailAddresses = (payload) => {
    return axios.post(`/MailGroupAdress/AddMany`, payload);
};

export const addMailAddressesNew = (payload) => {
    return axios.put(`/MailGroup/${payload.id}/relations`, payload.payloadData);
};

export const updateMailAddresses = (payload) => {
    return axios.post(`/MailGroupAdress/UpdateMany`, payload);
};

export const deleteMailAddress = (payload) => {
    return axios.delete(`/MailGroupAdress/Delete?id=${payload}`);
};
